'use client';

import { signIn } from 'next-auth/react';
import { useSearchParams } from 'next/navigation';
import { useEffect, useRef, useState } from 'react';

type SocialLoginProvider = 'line' | 'apple';

export const useSocialLogin = () => {
  const searchParams = useSearchParams();
  const pendingLoginProviderRef = useRef<SocialLoginProvider | null>(null);
  const [pendingLoginProvider, setPendingLoginProvider] = useState<SocialLoginProvider | null>(null);

  useEffect(() => {
    const resetPendingLoginOnHistoryRestore = (event: PageTransitionEvent) => {
      if (!event.persisted) return;

      pendingLoginProviderRef.current = null;
      setPendingLoginProvider(null);
    };

    window.addEventListener('pageshow', resetPendingLoginOnHistoryRestore);
    return () => window.removeEventListener('pageshow', resetPendingLoginOnHistoryRestore);
  }, []);

  const login = async (provider: SocialLoginProvider) => {
    if (pendingLoginProviderRef.current) return;

    pendingLoginProviderRef.current = provider;
    setPendingLoginProvider(provider);

    try {
      const redirectUri = searchParams?.get('redirect_uri') ?? '/mypage';
      await signIn(provider, { callbackUrl: redirectUri });
    } catch (_error) {
      pendingLoginProviderRef.current = null;
      setPendingLoginProvider(null);
      alert('ログインに失敗しました');
    }
  };

  return {
    loginWithLine: () => login('line'),
    loginWithApple: () => login('apple'),
    pendingLoginProvider,
    isLoginPending: pendingLoginProvider !== null,
  };
};
